import React, { useState, useEffect } from 'react';
import LaravelApi from '../laravelApi/LaravelApi';
import { Link } from "react-router-dom";

const BlogList = () => {
  const [blogList, setBlogList] = useState(false);
  
  useEffect(() => {
    fetchData();
  });

  const fetchData = async () => {
    const response = await LaravelApi.get('/blog', {   });
    setBlogList(response.data);
  };

  if (blogList !== false) {
    const listItems = blogList.map((entry) => 
          <ul>
            <li>{entry.id}</li>
            <li>{entry.title}</li>
            <li><Link to={{
              pathname: '/blog-create',
              state: {
                id: entry.id,
              }
            }}>Go to</Link></li>
          </ul>
        ); 
    return (    
      <div>
        {listItems}
      </div>
    );
  }

  return null;
}

export default BlogList;
